import React from "react";
import {
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepperProps,
} from "@UI/Components/Stepper/Stepper";
import { Box } from "@UI/Components/Box/Box";
import { Text } from "@UI/Components/Text/Text";
import { useSteps } from "@UI/hooks/useSteps";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";
import { useServiceRequestFlow } from "@modules/ServiceRequest/hooks/useServiceRequestFlow";

const steps = [
  {
    title: "serviceRequest.statusStep.1",
    description: "serviceRequest.statusStep.1.description",
  },
  {
    title: "serviceRequest.statusStep.2",
    description: "serviceRequest.statusStep.2.description",
  },
  {
    title: "serviceRequest.statusStep.3",
    description: "serviceRequest.statusStep.3.description",
  },
  {
    title: "serviceRequest.statusStep.4",
    description: "serviceRequest.statusStep.4.description",
  }
];

const spCreatedSteps = [
  {
    title: "serviceRequest.statusStep.spCreated.1",
    description: "serviceRequest.statusStep.spCreated.1.description",
  },
  {
    title: "serviceRequest.statusStep.spCreated.2",
    description: "serviceRequest.statusStep.spCreated.2.description",
  },
  steps[2],
  steps[3],
];

export const ServiceRequestStatusStepIndicator = (props: Partial<StepperProps>) => {
  const { serviceRequest } = useServiceRequestFlow();
  const isCreatedBySP =
    serviceRequest?.authorId && serviceRequest?.authorId !== serviceRequest?.userId;
  const activeSteps = isCreatedBySP ? spCreatedSteps : steps;

  const { activeStep } = useSteps({
    index: 1,
    count: activeSteps.length,
  });

  return (
    <Stepper
      index={activeStep}
      orientation="vertical"
      gap="0px"
      colorScheme="green"
      {...props}
    >
      {activeSteps.map((step, index) => (
        <Step key={index}>
          <StepIndicator
            background={activeStep === index ? "transparent" : "gray.200"}
          >
            <StepStatus
              complete={<StepIcon />}
              incomplete={
                <StepNumber
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    fontSize: "0.875rem",
                  }}
                />
              }
              active={
                <StepNumber
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    fontSize: "0.875rem",
                  }}
                />
              }
            />
          </StepIndicator>

          <Box>
            <StepNumber>
              <Text
                as="h5"
                color="gray.800"
                fontWeight="700"
                fontSize="md"
                lineHeight="24px"
              >
                <FormattedMessage
                  {...messages[step.title]}
                  values={{ spName: serviceRequest?.authorFirstName || "" }}
                />
              </Text>
            </StepNumber>
            <StepNumber>
              <Text fontSize="sm">
                <FormattedMessage {...messages[step.description]} />
              </Text>
            </StepNumber>
          </Box>

          <StepSeparator />
        </Step>
      ))}
    </Stepper>
  );
};
